/** French candidate strings — interview. Key = the exact English text passed to t(), value = French. */
const fr = {
  // ── Interview complete page (step labels are shared with the join page) ──
  'Back to {name}': 'Retour à {name}',
  'Your results appear there in a minute or two.': 'Vos résultats y apparaîtront d’ici une à deux minutes.',
  'Powered by': 'Propulsé par',
  'Your screening journey': 'Votre parcours de présélection',
  'Step {number}': 'Étape {number}',
  'Basic details': 'Informations de base',
  'Resume upload': 'Envoi du CV',
  'Document upload': 'Envoi de documents',
  'Application form': 'Formulaire de candidature',
  Assessment: 'Évaluation',
  'AI interview': 'Entretien IA',
  'AI video interview': 'Entretien vidéo IA',
  'AI voice interview': 'Entretien vocal IA',
  'Interview Complete!': 'Entretien terminé !',
  'What happens next?': 'Et maintenant ?',
  'Review process': 'Examen',
  'Our team will carefully review your interview responses.':
    'Notre équipe examinera attentivement vos réponses.',
  Evaluation: 'Évaluation',
  'Your responses will be evaluated against the role requirements.':
    'Vos réponses seront évaluées au regard des exigences du poste.',
  'Next steps': 'Prochaines étapes',
  "We'll contact you with next steps once the review is complete.":
    'Nous vous contacterons pour la suite une fois l’examen terminé.',
  'Check your inbox': 'Consultez votre boîte de réception',
  "We'll email you if any additional details are needed.":
    'Nous vous écrirons si des informations complémentaires sont nécessaires.',
  'Interview recorded': 'Entretien enregistré',
  'Your conversation has been securely saved for the hiring team.':
    'Votre conversation a été enregistrée de manière sécurisée pour l’équipe de recrutement.',
  Timeline: 'Délais',
  'Most candidates hear back within a few business days.':
    'La plupart des candidatures reçoivent une réponse sous quelques jours ouvrés.',
  'Complete Screening': 'Terminer la présélection',
  'If you have any questions, please reach out at the email provided in your invitation, or':
    'Pour toute question, écrivez à l’adresse e-mail indiquée dans votre invitation, ou',
  'contact support': 'contactez le support',

  // ── AI interview join page ──
  'Session Expired': 'Session expirée',
  'Your session expired. Please confirm your details to restart.':
    'Votre session a expiré. Veuillez confirmer vos informations pour recommencer.',
  'Loading...': 'Chargement...',
  'Role description will be provided during the interview.':
    'La description du poste vous sera présentée pendant l’entretien.',
  'Your privacy matters. This interview is secure and confidential.':
    'Votre confidentialité compte. Cet entretien est sécurisé et confidentiel.',
  'Need Help?': 'Besoin d’aide ?',
  'Need help?': 'Besoin d’aide ?',
  'Contact Support': 'Contacter le support',
  'Contact support': 'Contacter le support',
  'Loading AI interview…': 'Chargement de l’entretien IA…',
  'AI Interview Not Available': 'Entretien IA indisponible',
  'Go Back': 'Retour',
  'AI Interview Not Found': 'Entretien IA introuvable',
  "The AI interview you're looking for doesn't exist or is no longer available.":
    'L’entretien IA que vous recherchez n’existe pas ou n’est plus disponible.',
  'Your recruiter': 'Votre équipe de recrutement',
  'Preparing your interview…': 'Préparation de votre entretien…',
  'Taking you to the start screen.': 'Redirection vers l’écran de démarrage.',
  'Leave this page?': 'Quitter cette page ?',
  'Refreshing or closing this page may auto-submit your assessment and affect your progress. Please stay on this page until you complete this step or your time runs out.':
    'Actualiser ou fermer cette page peut soumettre automatiquement votre évaluation et affecter votre progression. Veuillez rester sur cette page jusqu’à la fin de cette étape ou de votre temps imparti.',
  'Start your interview': 'Commencez votre entretien',
  'Time up – window closed': 'Temps écoulé – délai expiré',
  'Start within {time}': 'Temps restant pour commencer : {time}',
  'You need to start the AI interview within 10 minutes of opening this page. After that, your screening window may automatically close based on your deadline.':
    'Vous devez commencer l’entretien IA dans les 10 minutes suivant l’ouverture de cette page. Passé ce délai, votre période de présélection peut se fermer automatiquement selon votre date limite.',
  'Takes about 2 mins': 'Environ 2 minutes',
  'Complete the interview in one sitting.': 'Effectuez l’entretien en une seule fois.',
  'Be natural and confident': 'Exprimez-vous avec naturel et assurance',
  'Speak clearly and take your time.': 'Parlez distinctement et prenez votre temps.',
  'This interview is proctored': 'Cet entretien est surveillé',
  "Please don't use external help.": 'Veuillez ne recourir à aucune aide extérieure.',
  'Quiet spot & strong Wi‑Fi': 'Endroit calme et bon Wi‑Fi',
  'Minimize distractions around you.': 'Limitez les distractions autour de vous.',
  'View job and interview details': 'Voir les détails du poste et de l’entretien',
  'Video interview with AI': 'Entretien vidéo avec l’IA',
  'Voice interview with AI': 'Entretien vocal avec l’IA',
  'Get ready for your interview!': 'Préparez-vous pour votre entretien !',
  'Enter your details to continue to the interview.':
    'Saisissez vos informations pour accéder à l’entretien.',
  'Full name': 'Nom complet',
  Email: 'E-mail',
  'Your full name': 'Votre nom complet',
  'Prefilled from the link and cannot be changed.': 'Prérempli à partir du lien et non modifiable.',
  "Time's up": 'Temps écoulé',
  'Verifying…': 'Vérification…',
  Next: 'Suivant',
  "Don't use external help or leave the session.":
    'N’utilisez aucune aide extérieure et ne quittez pas la session.',
  'Camera on throughout': 'Caméra allumée en permanence',
  'Position yourself clearly in the frame with good lighting.':
    'Placez-vous bien dans le cadre, avec un bon éclairage.',
  'Reviewed by a human': 'Examiné par une personne',
  'A recruiter will review your interview.':
    'Un membre de l’équipe de recrutement examinera votre entretien.',
  'Before you begin': 'Avant de commencer',
  'Camera & Audio:': 'Caméra et audio :',
  'You will be recorded via webcam and microphone':
    'Votre session sera enregistrée par la webcam et le microphone',
  'Attire:': 'Tenue :',
  'Please dress appropriately (formal or professional attire)':
    'Veuillez porter une tenue appropriée (tenue formelle ou professionnelle)',
  'Environment:': 'Environnement :',
  'Ensure a quiet, well-lit space with stable internet':
    'Installez-vous dans un endroit calme et bien éclairé, avec une connexion Internet stable',
  'Important:': 'Important :',
  'Start within 2 mins. Cannot be restarted once begun':
    'Commencez dans les 2 min. Aucun redémarrage possible une fois lancé',
  'Start Interview': 'Commencer l’entretien',

  // ── Join page errors (shown through t(errorMessage)) ──
  'AI Interview not found or no longer available': 'Entretien IA introuvable ou plus disponible',
  'Failed to load AI interview. Please check the link and try again.':
    'Impossible de charger l’entretien IA. Veuillez vérifier le lien et réessayer.',
  'Please provide both name and email': 'Veuillez indiquer votre nom et votre adresse e-mail',
  'Please enter a valid email address': 'Veuillez saisir une adresse e-mail valide',
  'Your screening window has ended. You can no longer start this AI interview.':
    'Votre période de présélection est terminée. Vous ne pouvez plus commencer cet entretien IA.',
  'You are not invited to take this AI interview. Please contact the interview creator.':
    'Votre adresse ne figure pas parmi les invitations à cet entretien IA. Veuillez contacter la personne qui l’a créé.',
  'Failed to start AI interview. Please try again.':
    'Impossible de démarrer l’entretien IA. Veuillez réessayer.',

  // ── Server messages a candidate can see (share link, session/start) ──
  'Interview not found': 'Entretien introuvable',
  'This interview is no longer available. The associated job posting has been deleted or cancelled.':
    'Cet entretien n’est plus disponible. L’offre d’emploi associée a été supprimée ou annulée.',
  'You have already completed this interview. Multiple attempts are not allowed.':
    'Vous avez déjà effectué cet entretien. Les tentatives multiples ne sont pas autorisées.',
  'Your organisation has used all available credits for this billing period.':
    'Votre organisation a utilisé tous les crédits disponibles pour cette période de facturation.',
  'Failed to start interview session': 'Impossible de démarrer la session d’entretien',
  'Server error': 'Erreur du serveur',

  // ── Device check (pre-test) page ──
  'Missing required information. Please go back and try again.':
    'Informations requises manquantes. Veuillez revenir en arrière et réessayer.',
  'Video and audio check': 'Vérification vidéo et audio',
  'Check your setup before starting.': 'Vérifiez votre configuration avant de commencer.',
  'Audio settings': 'Paramètres audio',
  Microphone: 'Microphone',
  'Microphone {id}': 'Microphone {id}',
  Speaker: 'Haut-parleur',
  'Speaker {id}': 'Haut-parleur {id}',
  'Playing...': 'Lecture…',
  'Test speaker': 'Tester le haut-parleur',
  'Video settings': 'Paramètres vidéo',
  'Camera access required': 'Accès à la caméra requis',
  'Allow Camera': 'Autoriser la caméra',
  'Camera ready': 'Caméra prête',
  "Smile, you're on camera!": 'Souriez, la caméra est allumée !',
  'Center yourself in the frame. This interview will be recorded.':
    'Placez-vous au centre du cadre. Cet entretien sera enregistré.',
  Camera: 'Caméra',
  'Camera {id}': 'Caméra {id}',
  'Camera not required for voice interviews': 'Caméra non requise pour les entretiens vocaux',
  'This is a voice-only interview. Audio will be recorded automatically.':
    'Cet entretien est uniquement vocal. L’audio sera enregistré automatiquement.',
  'All interview slots are currently in use': 'Tous les créneaux d’entretien sont actuellement occupés',
  'Please wait a few minutes and try again. The button will re-enable shortly.':
    'Veuillez patienter quelques minutes et réessayer. Le bouton sera bientôt réactivé.',
  'Starting interview...': 'Démarrage de l’entretien…',
  'Waiting for available slot...': 'En attente d’un créneau disponible…',
  'Start interview': 'Commencer l’entretien',

  // ── Pre-test errors (shown through t(livekitError)) ──
  'Microphone access denied. Please allow microphone permissions.':
    'Accès au microphone refusé. Veuillez autoriser l’accès au microphone.',
  'Failed to get LiveKit token': 'Impossible d’établir la connexion à l’entretien',
  'Invalid LiveKit URL format': 'Adresse de connexion à l’entretien invalide',
  'Failed to initialize interview connection': 'Impossible d’initialiser la connexion à l’entretien',

  // ── Server messages from session/livekit-token ──
  'Session not found': 'Session introuvable',
  'Invalid session access token': 'Jeton d’accès à la session invalide',
  'You have already completed this interview.': 'Vous avez déjà effectué cet entretien.',
  'Your application has already been processed and does not meet the criteria to proceed.':
    'Votre candidature a déjà été traitée et ne remplit pas les critères pour poursuivre.',
  'Session does not match this interview.': 'La session ne correspond pas à cet entretien.',
  'This interview is no longer available.': 'Cet entretien n’est plus disponible.',
  'All interview slots are currently in use. Please wait a few minutes and try again.':
    'Tous les créneaux d’entretien sont actuellement occupés. Veuillez patienter quelques minutes et réessayer.',
  'Something went wrong': 'Une erreur s’est produite',

  // ── Live interview page ──
  'Microphone Permission Required': 'Autorisation du microphone requise',
  'Connection Error': 'Erreur de connexion',
  'Try again': 'Réessayer',
  Retry: 'Réessayer',
  Dismiss: 'Fermer',
  'Preparing interview': 'Préparation de l’entretien',
  'Your interviewer dropped out for a moment. Reconnecting you now — please stay on this page.':
    'La connexion avec l’intervieweur IA a été brièvement interrompue. Reconnexion en cours — veuillez rester sur cette page.',
  'Your answers so far are saved. The interview will carry on from where it stopped.':
    'Vos réponses jusqu’ici sont enregistrées. L’entretien reprendra là où il s’est arrêté.',
  'This is taking longer than expected. You can keep waiting or try refreshing.':
    'Cela prend plus de temps que prévu. Vous pouvez continuer à patienter ou actualiser la page.',
  'Keep waiting': 'Continuer à patienter',
  'Refresh & retry': 'Actualiser et réessayer',
  "We're preparing your interview. Please wait a moment before we begin.":
    'Nous préparons votre entretien. Veuillez patienter un instant avant de commencer.',
  "We're still connecting to your interviewer. This is taking longer than expected. You can keep waiting, or try refreshing the page. If the issue continues, please try again in a few minutes.":
    'La connexion avec l’intervieweur IA est toujours en cours. Cela prend plus de temps que prévu. Vous pouvez continuer à patienter ou actualiser la page. Si le problème persiste, veuillez réessayer dans quelques minutes.',
  'Leave interview': 'Quitter l’entretien',
  'No audio from interviewer yet.': 'Aucun son de l’intervieweur IA pour le moment.',
  "Your browser is connected but we haven't received any sound. Please ensure your speaker volume is up and try waiting a few more seconds. If this continues, try refreshing the page.":
    'Votre navigateur est connecté, mais aucun son n’a encore été reçu. Vérifiez que le volume de votre haut-parleur est suffisant et patientez quelques secondes. Si le problème persiste, actualisez la page.',
  'Entering Fullscreen Mode': 'Passage en mode plein écran',
  'Please wait while we set up your secure interview environment...':
    'Veuillez patienter pendant la préparation de votre environnement d’entretien sécurisé…',
  'Microphone required': 'Microphone requis',
  'Allow microphone access to continue.': 'Autorisez l’accès au microphone pour continuer.',
  'Voice assistant controls (connecting...)': 'Commandes de l’assistant vocal (connexion en cours…)',
  'Connecting...': 'Connexion…',
  'End call (connecting)': 'Terminer l’appel (connexion en cours)',
  'END CALL': 'TERMINER L’APPEL',
  END: 'FIN',
  'Taking you to the completion page...': 'Redirection vers la page de fin…',

  // ── Live interview errors and agent warnings (shown through translateInterviewMessage) ──
  '{reason}. Please refresh the page.': '{reason}. Veuillez actualiser la page.',
  'Failed to reconnect': 'Échec de la reconnexion',
  'Connection token expired or invalid': 'Jeton de connexion expiré ou invalide',
  'Network connection failed': 'Échec de la connexion réseau',
  'Connection was interrupted': 'La connexion a été interrompue',
  'Invalid server configuration': 'Configuration du serveur invalide',
  'Interview room not found': 'Salle d’entretien introuvable',
  'Microphone access is required for this interview. Please enable microphone permissions and refresh the page.':
    'L’accès au microphone est requis pour cet entretien. Veuillez autoriser le microphone et actualiser la page.',
  'Please keep your microphone enabled during the interview. Excessive muting is not allowed.':
    'Veuillez laisser votre microphone activé pendant l’entretien. Couper le micro de manière répétée n’est pas autorisé.',
  'Something went wrong with the interview. Please refresh the page to try again.':
    'Un problème est survenu pendant l’entretien. Veuillez actualiser la page pour réessayer.',
  "We couldn't load your interview questions. Please refresh the page to try again.":
    'Impossible de charger les questions de votre entretien. Veuillez actualiser la page pour réessayer.',
  'The interview could not start due to a configuration error. Please refresh the page to try again.':
    'L’entretien n’a pas pu démarrer en raison d’une erreur de configuration. Veuillez actualiser la page pour réessayer.',
  'The interview could not start. Please refresh the page to try again.':
    'L’entretien n’a pas pu démarrer. Veuillez actualiser la page pour réessayer.',
  "We can't hear your microphone. Please make sure your microphone is enabled and refresh the page.":
    'Nous n’entendons pas votre microphone. Vérifiez qu’il est activé, puis actualisez la page.',
  'There may be an issue with your connection.': 'Il se peut que votre connexion rencontre un problème.',
  'We are not picking up speech yet (this can happen right after you reconnect). If you already allowed the mic, try speaking an answer — or dismiss this and continue. Refresh only if the interviewer still cannot hear you.':
    'Nous ne captons pas encore votre voix (cela peut arriver juste après une reconnexion). Si vous avez déjà autorisé le micro, essayez de répondre à voix haute — ou fermez ce message et continuez. N’actualisez la page que si l’intervieweur IA ne vous entend toujours pas.',
  "We're having trouble hearing you clearly. Please speak closer to your microphone.":
    'Nous avons du mal à vous entendre clairement. Veuillez parler plus près de votre microphone.',
  'Re-establishing your audio connection…': 'Rétablissement de votre connexion audio…',
  'We lost access to your microphone (this can happen after a phone call). Please tap the screen — and refresh the page if the interviewer still cannot hear you.':
    'L’accès à votre microphone a été perdu (cela peut arriver après un appel téléphonique). Touchez l’écran — et actualisez la page si l’intervieweur IA ne vous entend toujours pas.',
  'Connection lost. Please refresh the page.': 'Connexion perdue. Veuillez actualiser la page.',
  'Failed to reconnect after multiple attempts. Please refresh the page.':
    'Échec de la reconnexion après plusieurs tentatives. Veuillez actualiser la page.',
  'Could not get connection. Please refresh the page.':
    'Impossible d’obtenir une connexion. Veuillez actualiser la page.',
  'Connection failed. Please refresh the page.': 'Échec de la connexion. Veuillez actualiser la page.',
  'Missing required information. Please go back and enter your details.':
    'Informations requises manquantes. Veuillez revenir en arrière et saisir vos informations.',
  'Interview credits have been exhausted for this organisation. Please contact the recruiter.':
    'Les crédits d’entretien de cette organisation sont épuisés. Veuillez contacter l’équipe de recrutement.',
  'Too many requests. Please wait a moment and refresh the page to try again.':
    'Trop de requêtes. Veuillez patienter un instant, puis actualiser la page pour réessayer.',
  'All interview slots are currently busy. Please wait 1-2 minutes and refresh the page to try again.':
    'Tous les créneaux d’entretien sont actuellement occupés. Veuillez patienter 1 à 2 minutes, puis actualiser la page pour réessayer.',
  'Could not access your microphone. Please check your audio device and browser permissions, then refresh the page.':
    'Impossible d’accéder à votre microphone. Vérifiez votre périphérique audio et les autorisations du navigateur, puis actualisez la page.',
  'Failed to start session': 'Impossible de démarrer la session',
  'Failed to start interview': 'Impossible de démarrer l’entretien',
  'The request timed out. Please check your internet connection and refresh the page to try again.':
    'La requête a expiré. Veuillez vérifier votre connexion Internet, puis actualiser la page pour réessayer.',

  // ── Agent control bar, transcript, avatar, device controls ──
  'Type something...': 'Saisissez un message…',
  'Sending...': 'Envoi…',
  Send: 'Envoyer',
  'Voice assistant controls': 'Commandes de l’assistant vocal',
  Connected: 'Connexion établie',
  Connecting: 'Connexion en cours',
  'Toggle microphone': 'Activer ou couper le microphone',
  'Toggle screen share': 'Activer ou désactiver le partage d’écran',
  'Toggle transcript': 'Afficher ou masquer la transcription',
  'End call': 'Terminer l’appel',
  'Interview conversation transcript': 'Transcription de la conversation d’entretien',
  'Conversation will appear here shortly.': 'La conversation s’affichera ici dans un instant.',
  'Interviewer speaking': 'L’intervieweur IA parle',
  'Interviewer listening': 'L’intervieweur IA écoute',
  'No microphones found': 'Aucun microphone détecté',

  // ── Proctoring indicator (Ctrl+Shift+V panel) ──
  'Proctoring Active': 'Surveillance active',
  'Fullscreen Active': 'Plein écran actif',
  'Fullscreen Required': 'Plein écran requis',
  'Right-clicks: {count}': 'Clics droits : {count}',
  'Shift-clicks: {count}': 'Clics avec Maj : {count}',
  'Recent Activity:': 'Activité récente :',
  'All activities are being monitored and recorded': 'Toutes les activités sont surveillées et enregistrées',
  'Copy detected': 'Copie détectée',
  'Paste detected': 'Collage détecté',
  'Keyboard copy (Ctrl+C)': 'Copie au clavier (Ctrl+C)',
  'Keyboard paste (Ctrl+V)': 'Collage au clavier (Ctrl+V)',
  'Keyboard cut (Ctrl+X)': 'Coupe au clavier (Ctrl+X)',
  'Cut detected': 'Coupe détectée',
  'Tab switched': 'Changement d’onglet',
  'Tab returned': 'Retour sur l’onglet',
  'Alt+Tab detected': 'Alt+Tab détecté',
  'Window lost focus': 'Fenêtre inactive',
  'Window focused': 'Fenêtre active',
  'Fullscreen entered': 'Plein écran activé',
  'Fullscreen exited': 'Plein écran quitté',
  'Right-click blocked': 'Clic droit bloqué',
  'Shift+Click detected': 'Maj+Clic détecté',
  'Shift key pressed': 'Touche Maj enfoncée',
  'Activity detected': 'Activité détectée',

  // ── Waiting room (InterviewWaitingLobby) ──
  "You're in the waiting room": 'Vous êtes en salle d’attente',
  'Your interviewer will be with you shortly': 'Votre intervieweur IA sera bientôt disponible',
  "All our AI interviewers are talking with other candidates right now. You're in line, and your interview will start automatically as soon as one is free.":
    'Tous nos intervieweurs IA sont en entretien avec d’autres candidats. Vous êtes dans la file d’attente et votre entretien commencera automatiquement dès que l’un d’eux sera libre.',
  'Getting your interview ready': 'Préparation de votre entretien',
  'Connecting you to your interviewer…': 'Connexion à votre intervieweur IA…',
  'This is taking a little longer than usual. We are retrying automatically — no need to do anything.':
    'Cela prend un peu plus de temps que d’habitude. Nous réessayons automatiquement, vous n’avez rien à faire.',
  "We couldn't connect you just now": 'Nous n’avons pas pu vous connecter pour le moment',
  'Your place in line': 'Votre place dans la file',
  "You're next": 'C’est bientôt votre tour',
  'Estimated wait': 'Attente estimée',
  'About {low}–{high} min': 'Environ {low} à {high} min',
  'Checking for a free interviewer…': 'Recherche d’un intervieweur IA disponible…',
  'Reconnecting…': 'Reconnexion…',
  'Keep this tab open': 'Gardez cet onglet ouvert',
  'You keep your place in line while this page stays open.':
    'Vous gardez votre place dans la file tant que cette page reste ouverte.',
  'Stay somewhere quiet': 'Restez dans un endroit calme',
  'Your interview starts the moment an interviewer is free.':
    'Votre entretien commence dès qu’un intervieweur IA est libre.',
  "Waiting doesn't count": 'L’attente ne compte pas',
  'Time in the waiting room is not part of your interview.':
    'Le temps passé en salle d’attente ne fait pas partie de votre entretien.',
  "We couldn't connect you to your interviewer. Please check your internet connection and try again.":
    'Nous n’avons pas pu vous connecter à votre intervieweur IA. Vérifiez votre connexion Internet et réessayez.',
  'Our interviewers are still busy. Please try again in a few minutes.':
    'Nos intervieweurs IA sont toujours occupés. Veuillez réessayer dans quelques minutes.',
  "We couldn't reach your interviewer just now. Please try again in a moment.":
    'Nous n’avons pas pu joindre votre intervieweur IA. Veuillez réessayer dans un instant.',

  // ── Interview readiness check (InterviewReadinessModal) ──
  'Interview check': 'Vérification avant l’entretien',
  'Step {current} of 2': 'Étape {current} sur 2',
  'Get ready to speak clearly': 'Préparez-vous à parler clairement',
  'Voice check': 'Vérification de la voix',
  'Read the sentence below out loud, a little loud and clear — the way you will answer in the interview.':
    'Lisez la phrase ci-dessous à voix haute, assez fort et clairement — comme vous répondrez pendant l’entretien.',
  'I am ready for my interview, and I will answer every question clearly and loudly.':
    'Je suis prêt(e) pour mon entretien et je répondrai à chaque question clairement et à voix haute.',
  'Too soft': 'Trop faible',
  Good: 'Bien',
  'We can hear you, but please speak louder.': 'Nous vous entendons, mais parlez plus fort, s’il vous plaît.',
  'Your voice was too soft. Please read the sentence again, a little louder.':
    'Votre voix était trop faible. Relisez la phrase, un peu plus fort.',
  'There is a lot of noise around you. Move somewhere quieter, or speak louder, and try again.':
    'Il y a beaucoup de bruit autour de vous. Installez-vous dans un endroit plus calme, ou parlez plus fort, puis réessayez.',
  "We couldn't hear you. Check that the right microphone is selected and read the sentence again.":
    'Nous ne vous avons pas entendu. Vérifiez que le bon microphone est sélectionné et relisez la phrase.',
  'Listening… start reading now.': 'À l’écoute… commencez à lire maintenant.',
  'Voice checked!': 'Voix vérifiée !',
  'Speak just as loudly as this during your interview.':
    'Parlez aussi fort que cela pendant votre entretien.',
  "We couldn't use your microphone. Allow microphone access in your browser, close other apps using it, and try again.":
    'Nous n’avons pas pu utiliser votre microphone. Autorisez l’accès au microphone dans votre navigateur, fermez les autres applications qui l’utilisent, puis réessayez.',
  'Next: camera check': 'Suivant : vérification de la caméra',
  'Listening…': 'À l’écoute…',
  'Start voice check': 'Lancer la vérification de la voix',
  'Camera check': 'Vérification de la caméra',
  'Sit down where you will take the interview, in good light, with your face inside the oval. Then tap "Check me" and stay still for 10 seconds.':
    'Asseyez-vous là où vous passerez l’entretien, dans un endroit bien éclairé, le visage dans l’ovale. Touchez ensuite « Me vérifier » et restez immobile pendant 10 secondes.',
  'Stay still… photo {count} of 3': 'Restez immobile… photo {count} sur 3',
  'Checking how you appear…': 'Vérification de votre image…',
  'You look ready. Keep sitting just like this during the interview.':
    'Vous semblez prêt(e). Restez assis(e) ainsi pendant l’entretien.',
  'Please fix this and check again:': 'Corrigez ceci puis vérifiez à nouveau :',
  "We couldn't use your camera. Allow camera access in your browser, close other apps using it, and try again.":
    'Nous n’avons pas pu utiliser votre caméra. Autorisez l’accès à la caméra dans votre navigateur, fermez les autres applications qui l’utilisent, puis réessayez.',
  'Checking…': 'Vérification…',
  'Check me again': 'Me vérifier à nouveau',
  'Check me': 'Me vérifier',
  'Continue to the interview anyway': 'Continuer vers l’entretien malgré tout',
  "We can't see you. Please sit in front of the camera.":
    'Nous ne vous voyons pas. Asseyez-vous face à la caméra.',
  'Only you should be in the camera view.': 'Vous seul(e) devez apparaître à l’écran.',
  'Please sit down in one place and stay there for the interview.':
    'Asseyez-vous à un endroit et restez-y pendant l’entretien.',
  'Keep your whole face visible and look at the screen.':
    'Gardez tout votre visage visible et regardez l’écran.',
  'Move closer to the camera.': 'Rapprochez-vous de la caméra.',
  'Move a little back from the camera.': 'Reculez un peu par rapport à la caméra.',
  'Move so your face is in the middle of the frame.':
    'Placez-vous de façon à avoir le visage au centre de l’image.',
  'Your face is too dark. Sit facing a light or a window.':
    'Votre visage est trop sombre. Placez-vous face à une lumière ou à une fenêtre.',
  'Please wear a shirt or T-shirt. Your interview is recorded on video.':
    'Veuillez porter une chemise ou un T-shirt. Votre entretien est enregistré en vidéo.',
};

export default fr;
